import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'project-description',
  templateUrl: './project-description.component.html',
  styleUrls: ['./project-description.component.scss']
})
export class ProjectDescriptionComponent implements OnInit {
  public options: [];
  constructor() {}

  ngOnInit() {
    this.options = [];
  }

  positionChange(event) {}

  projectChosen(event) {}
}
